import { put, takeLatest } from 'redux-saga/effects';
import { PersonalTask, PersonalTaskAPI } from 'api/personal-tasks';
import { logger } from 'services';
import { deleteStart, deleteSuccess, deleteFailed } from '..';
import { StoreActionProps } from '../../core';
import { deletePersonalTaskSagaAction } from '../actions';

function* deletePersonalTaskSaga(action: StoreActionProps<PersonalTask>) {
  const { payload } = action;

  try {
    yield put(deleteStart(payload));
    yield PersonalTaskAPI.deletePersonalTask(payload.personalTaskId);
    yield put(deleteSuccess(payload));
  } catch (error) {
    logger.error('deletePersonalTask failed', { error });
    yield put(deleteFailed());
  }
}

export function* watchDeletePersonalTasksSaga(): Generator {
  yield takeLatest(deletePersonalTaskSagaAction.type, deletePersonalTaskSaga);
}
